import React from 'react';

const HorizontalRule = () => {
    return <hr className="pds-u-margin-vertical-8 horizontal-rule"/>
};

export default HorizontalRule;
